import React, { Component } from "react";
import { ReactComponent as IconLeft } from "../../../resources/image/ic_left.svg";

class Adapter extends Component {
  state = {
    deleteModalShow: false,
  };

  render() {
    const { item, onSelect } = this.props;

    return (
      <div style={{ marginBottom: 16 }} className="row mb-4 mr-0 mx-auto col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">

        <div
          className="app-card col-12 clickable row m-0 "
          style={{ textDecoration: "none", textAlign: "left" }}
          onClick={() => onSelect(item)}
        >

          <div className="col-11" style={{textAlign: "right"}}>

            <img
              height="20"
              src={item.pictureUrl}
              alt=""
            />

            <div style={{ color: "gray", fontSize: 13, marginRight: 1, marginTop: 5 }}> {item.title}</div>

          </div>

          <IconLeft
            className="p-0 col-1 mt-2"
            width="25"
            height="25"
            color="darkGray" />



        </div>

      </div>

    );
  }
}

export default Adapter;
